/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Import_HelpInputs */



/**
* | output |
* | --- |
* | "Import event groups and/or metadata without overwriting the existing project file" |
*
* @param {Merge_Import_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_import_help = /** @type {((inputs?: Merge_Import_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Import_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des groupes d’événements et/ou des métadonnées sans écraser le projet existant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie Ereignisgruppen und/oder Metadaten, ohne die bestehende Projektdatei zu überschreiben.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa gruppi di eventi e/o metadati senza sovrascrivere il file di progetto esistente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте группы событий и/или метаданные без перезаписи существующего файла проекта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar grupos de eventos y/o metadatos sin sobrescribir el archivo de proyecto existente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入事件组和/或元数据，而不覆盖现有项目文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("既存のプロジェクト ファイルを上書きせずにイベント グループやメタデータをインポートします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मौजूदा प्रोजेक्ट फ़ाइल को ओवरराइट किए बिना इवेंट समूह और/या मेटाडेटा आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe grupos de eventos e/ou metadados sem sobrescrever o arquivo de projeto existente.")
	return /** @type {LocalizedString} */ ("Import event groups and/or metadata without overwriting the existing project file")
});